import { AppTable } from '@components/AppTable';
import { BorderButton, StyledButton } from '@elements/Button';
import { AppModal } from '@elements/Modal';
import { useMemo } from 'react';
import { cn } from '@skupreme/shared/ui';
import { FlexColumn } from '@elements/Common';
import { itemColumns } from './common';
import { ConfirmItemRow } from './ComponentRow';

const TABLE_SCOPE = cn(
  'sk:[&_tr_th]:border-b-0! sk:[&_tr_th]:pl-0!',
  'sk:[&_.table-wrapper]:max-h-[80vh] sk:[&_.table-wrapper]:overflow-y-auto',
  'sk:[&_.table-wrapper_thead_tr_th]:sticky sk:[&_.table-wrapper_thead_tr_th]:top-0',
);

export function ConfirmationPopup({
  open,
  closeModal,
  items,
  confirm,
  lineItems,
  imperial,
  currency,
}) {
  const data = useMemo(
    () =>
      [
        // @ts-expect-error - TS18046: 'x' is of type 'unknown'.
        ...Object.values(items).filter(x => x.qty > 0),
        ...lineItems.map(item => ({
          title: (
            <FlexColumn className="sk:items-start!">
              <b>Custom Line Item:</b>
              <div>{item.item_name}</div>
            </FlexColumn>
          ),
          qty: item.qty,
          current_price: item.price,
          total: (item.qty || 0) * (item.price || 0),
          aliases: {},
          isComponent: true,
        })),
      ].map(x => ({
        id: Math.random(),
        ...x,
      })),
    [items, lineItems],
  );

  const componentColumns = useMemo(() => itemColumns, []);

  return (
    <AppModal
      open={open}
      size="large"
      title="Confirmation"
      closeModal={() => closeModal()}
    >
      <div className={cn(TABLE_SCOPE, !(data || []).length && 'sk:-mt-7')}>
        <AppTable
          RowComponent={
            /* @ts-expect-error - TS2741: Property 'item' is missing in type '{ currency: any; imperia... */
            <ConfirmItemRow currency={currency} imperial={imperial} />
          }
          data={data || []}
          keyField="id"
          // @ts-expect-error - TS2322: Type '({ text: string; width: number; key: string; sortKey?: undefined; componen...
          columns={componentColumns}
          wrapperClass="table-wrapper sk:my-1!"
          noShadow
        />
      </div>
      <div className="sk:text-right">
        <BorderButton
          type="button"
          className="sk:mt-2!"
          onClick={() => closeModal()}
        >
          Cancel
        </BorderButton>
        <StyledButton
          type="submit"
          onClick={() => {
            closeModal(), confirm();
          }}
        >
          Confirm
        </StyledButton>
      </div>
    </AppModal>
  );
}
